/******************************************************************
 * ShadowEffects
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class ShadowEffects {
    static readonly META_BUTTON_SHADOW = "1px 2px 10px 0 rgba(0,0,0,0.05)";
}
